/** Option A: short directional fade/slide on the scroll content after a swipe tab change. */

const ANIM_CLASS_NEXT = 'tab-swipe-anim-next';
const ANIM_CLASS_PREV = 'tab-swipe-anim-prev';
const ANIM_CLASSES = [ANIM_CLASS_NEXT, ANIM_CLASS_PREV];

export function playTabSwipeContentAnimation(
	host: HTMLElement | null | undefined,
	direction: 1 | -1,
): void {
	if (!host) return;

	const target = (host.querySelector('.scroll-content-new-layout') as HTMLElement | null) ?? host;

	target.classList.remove(...ANIM_CLASSES);
	// Force reflow so re-adding the class restarts the animation.
	void target.offsetWidth;
	target.classList.add(direction > 0 ? ANIM_CLASS_NEXT : ANIM_CLASS_PREV);
}
